import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://192.9.204.144:5001/api';

// 創建API實例
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 請求攔截器添加token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // config.headers['x-auth-token'] = token;
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 響應攔截器處理錯誤
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401錯誤處理 (未授權/token過期)
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (error.response.data.count !== 1) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('selectedCustomer');
        localStorage.removeItem('IOS');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    }
    return Promise.reject(error);
  }
);

// 身份驗證服務
// export const authService = {
//   register: (userData) => api.post('/auth/register', userData),
//   login: (credentials) => api.post('/auth/login', credentials),
//   logout: () => api.post('/auth/logout'),
//   getCurrentUser: () => api.get('/auth/me'),
//   updateProfile: (userData) => api.put('/auth/profile', userData)
// };

export default api;